module.exports = __webpack_public_path__ + "img/04.9992db65.webp";